"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentNotice = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const VARIANTS = {
    todo: { tone: 'info', label: 'TODO' },
    exception: { tone: 'info', label: '예외' },
};
/**
 * 가이드 문서에서 규칙 목록과 떼어 보여 주는 notice.
 * todo는 아직 정하지 않았거나 만들지 않은 것을, exception은 규칙을 벗어나는 사례를 알린다.
 * heading에 그 내용을, 기본 slot에 사례와 이유를 둔다.
 */
let ComponentNotice = class ComponentNotice extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'todo';
        this.heading = '';
    }
    render() {
        const { tone, label } = VARIANTS[this.variant];
        return (0, lit_1.html) `
      <mm-notice variant=${tone} heading="${label}: ${this.heading}">
        <mm-text size="14"><slot></slot></mm-text>
      </mm-notice>
    `;
    }
};
ComponentNotice.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentNotice.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentNotice.prototype, "heading", void 0);
ComponentNotice = __decorate([
    (0, decorators_js_1.customElement)('mm-component-notice')
], ComponentNotice);
exports.ComponentNotice = ComponentNotice;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LW5vdGljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbXBvbmVudC1ub3RpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUkzRCwrQkFBNEI7QUFJNUIsTUFBTSxRQUFRLEdBQUc7SUFDZixJQUFJLEVBQUUsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUU7SUFDckMsU0FBUyxFQUFFLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFO0NBQ2lELENBQUE7QUFFM0Y7Ozs7R0FJRztBQUVJLElBQU0sZUFBZSxHQUFyQixNQUFNLGVBQWdCLFNBQVEsZ0JBQVU7SUFBeEM7O1FBTXVCLFlBQU8sR0FBMkIsTUFBTSxDQUFBO1FBQ3hDLFlBQU8sR0FBRyxFQUFFLENBQUE7SUFXMUMsQ0FBQztJQVRDLE1BQU07UUFDSixNQUFNLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxHQUFHLFFBQVEsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7UUFFOUMsT0FBTyxJQUFBLFVBQUksRUFBQTsyQkFDWSxJQUFJLGFBQWEsS0FBSyxLQUFLLElBQUksQ0FBQyxPQUFPOzs7S0FHN0QsQ0FBQTtJQUNILENBQUM7O0FBaEJNLHNCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7R0FJbEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7Z0RBQXlDO0FBQ3hDO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztnREFBYTtBQVA3QixlQUFlO0lBRDNCLElBQUEsNkJBQWEsRUFBQyxxQkFBcUIsQ0FBQztHQUN4QixlQUFlLENBa0IzQjtBQWxCWSwwQ0FBZSJ9